import { apiClient } from './api';

export interface Customer {
  id: number;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  email?: string;
  status: string;
  kycLevel?: string;
  preferredLanguage?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CustomerWallet {
  id: number;
  walletId: string;
  customerId: number;
  status: string;
  balance: number;
  currency: string;
  createdAt: string;
  suspendedAt?: string;
  closedAt?: string;
}

export interface CustomerTransaction {
  id: number;
  walletId: string;
  type: string;
  amount: number;
  currency: string;
  status: string;
  description?: string;
  createdAt: string;
}

export interface CustomerIdentifier {
  id: number;
  customerId: number;
  type: string;
  value: string;
  isPrimary: boolean;
  verifiedAt?: string;
  createdAt: string;
}

export interface CustomerListResponse {
  data: Customer[];
  total: number;
  page: number;
  limit: number;
}

export const customerService = {
  async getCustomers(params: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
  }): Promise<CustomerListResponse> {
    const response = await apiClient.get('/customer-identity/list', { params });
    return response.data;
  },

  async getCustomerById(id: number): Promise<Customer> {
    const response = await apiClient.get(`/customer-identity/${id}`);
    return response.data;
  },

  async getCustomerWallets(customerId: number): Promise<CustomerWallet[]> {
    const response = await apiClient.get(`/customer-wallet/customer/${customerId}`);
    return response.data;
  },

  async getCustomerTransactions(walletId: string): Promise<CustomerTransaction[]> {
    const response = await apiClient.get(`/customer-wallet/${walletId}/transactions`);
    return response.data;
  },

  async getCustomerIdentifiers(customerId: number): Promise<CustomerIdentifier[]> {
    const response = await apiClient.get(`/customer-identity/${customerId}/identifiers`);
    return response.data;
  },

  async updateCustomer(id: number, data: Partial<Customer>): Promise<Customer> {
    const response = await apiClient.patch(`/customer-identity/${id}`, data);
    return response.data;
  },
};
